var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasSlideRemark && _vm.hasRemark)?_c('v-icon',{attrs:{"color":"blue darken-3"}},[_vm._v("event_note")]):(_vm.hasSlideRemark)?_c('v-icon',{attrs:{"color":"#FF5722"}},[_vm._v("event_note")]):_c('v-icon',[_vm._v("event_note")])
}
var staticRenderFns = []

export { render, staticRenderFns }